module.exports = __webpack_public_path__ + "media/favicons/favicon-b1892a0d.svg";